import { render, staticRenderFns } from "./DGR.vue?vue&type=template&id=170fcb11"
import script from "./DGR.vue?vue&type=script&lang=js"
export * from "./DGR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports